import { cn } from '@/utils/cn'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { type ComponentPropsWithoutRef, type ElementRef, type HTMLAttributes, forwardRef } from 'react'

export const Popover = PopoverPrimitive.Root

export const PopoverTrigger = PopoverPrimitive.Trigger

export const popoverContentStyles = cn(
  'z-50 overflow-hidden rounded-xl border bg-page',
  'data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:animate-out',
  'data-[state=open]:fade-in-0 data-[state=open]:animate-in',
  'data-[side=bottom]:slide-in-from-top-2',
  'data-[side=left]:slide-in-from-right-2',
  'data-[side=right]:slide-in-from-left-2',
  'data-[side=top]:slide-in-from-bottom-2'
)

export const PopoverContent = forwardRef<
  ElementRef<typeof PopoverPrimitive.Content>,
  ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'start', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(popoverContentStyles, 'w-[var(--radix-popover-trigger-width)]', className)}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export const PopoverList = ({ className, children, ...props }: HTMLAttributes<HTMLUListElement>) => {
  return (
    <ul className={cn('w-full', className)} {...props}>
      {children}
    </ul>
  )
}
PopoverList.displayName = 'PopoverList'

export const popoverListItemStyles = cn(
  'flex w-full select-none items-center text-sm outline-none transition-colors',
  'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50'
)

export const PopoverListItem = ({ className, children, ...props }: HTMLAttributes<HTMLLIElement>) => {
  return (
    <li className={cn(popoverListItemStyles, className)} {...props}>
      {children}
    </li>
  )
}
PopoverListItem.displayName = 'PopoverListItem'
